import React, { useEffect } from "react";

import {
  Container,
  Header,
  Logo,
  Content,
  Card,
  Slider,
  FormContainer,
  ButtonBar,
  Buttons,
  ActiveBar,
  FormLogin,
  FormSignUp,
} from "./LoginComponents.jsx";

import { animationbar } from "./animationbar.js";
import {animationlabel} from './animationlabel.js'

import image from "../../images/Savitar.png";

import { Link } from "react-router-dom";

import svg from "./img-2.svg";

function Login() {
  useEffect(() => {
    animationbar();
    animationlabel();

  }, []);


  return (
    <Container>
      <Header>
        <Link to="/">
          <Logo src={image} />
        </Link>
      </Header>
      <Content>
        <Card>
          <Slider>
            <ButtonBar>
              <Buttons id="login">Login</Buttons>
              <Buttons id="signup">Sign Up</Buttons>
              <ActiveBar id="bar" />
            </ButtonBar>
          </Slider>
          <FormContainer>
            <FormLogin id="loginform">
              <div className="loginform">
                <label htmlFor="" className="loginLabelGmail">Gmail</label>
                <input type="email" className="loginInputGmail"/>
              </div>
              <div className="loginform">
                <label htmlFor="" className="loginLabelPass">Password</label>
                <input type="password" className="loginInputPass"/>
              </div>
              <button type="submit">Log In</button>
            </FormLogin>
            <FormSignUp id="signupform">
              <div>
                <label htmlFor="" className="signLabelName">Name</label>
                <input type="name" className="signInputName"/>
              </div>
              <div>
                <label htmlFor="" className="signLabelGmail">Gmail</label>
                <input type="email" className="signInputGmail"/>
              </div>
              <div>
                <label htmlFor="" className="signLabelPass">Password</label>
                <input type="password" className="signInputPass"/>
              </div>
              <button type="submit">Sign Up</button>
            </FormSignUp>
          </FormContainer>
        </Card>
      </Content>
    </Container>
  );
}

export default Login;
